var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4091 12.3887L50.8285 20.2931V10.4158C50.8285 7.97627 48.8647 6 46.4403 6H14.9928L0 21.0883V43.9046V54.577C0 57.0166 1.96383 58.9929 4.38818 58.9929H14.9928H46.4403C48.8647 58.9929 50.8285 57.0166 50.8285 54.577V45.0677L60.4527 53.0094C61.893 54.1428 64 53.109 64 51.2655V14.0959C64 12.2303 61.846 11.2069 60.4091 12.3887ZM36.2015 43.9046H14.9928V21.0883H36.2015V32.4964V43.9046Z",
    fill: "#F5BB41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.9046V54.577C0 57.0166 1.96383 58.9929 4.38818 58.9929H14.9928V43.9046H0Z",
    fill: "#2167D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9928 21.0883H0V43.9046H14.9928V21.0883Z",
    fill: "#3D84F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4091 12.3886L50.8286 20.293V45.0677L60.4527 53.0094C61.8931 54.1428 64 53.109 64 51.2655V14.0959C64 12.2303 61.846 11.2069 60.4091 12.3886Z",
    fill: "#4CA853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2015 32.4964V43.9046H14.9929V58.9929H46.4404C48.8647 58.9929 50.8285 57.0166 50.8285 54.577V45.0677L36.2015 32.4964Z",
    fill: "#4CA853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8285 45.0677V20.3007L36.2015 32.4964L50.8285 45.0677Z",
    fill: "#398039"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0883H14.9928V6L0 21.0883Z",
    fill: "#D74F3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4404 6H14.9929V21.0883H36.2015V32.4964L50.8285 20.3007V20.2931V10.4158C50.8285 7.97627 48.8647 6 46.4404 6Z",
    fill: "#F5BB41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/google-meet.e3479ecbf4ba3c6d7a94080d48d4c1c0.svg";
export { ForwardRef as ReactComponent };